<div class="flex" style="margin-top: 8px;">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <div class="p-datatable-header">
        <div class="flex flex-column sm:flex-row justify-content-end">
          <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary"
              icon="pi pi-sliders-h"
            ></button>
          </div>
          <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary filtersFilled"
              icon="pi pi-filter"
            ></button>
          </div>
        </div>
      </div>
      <p-table
        [value]="sharedResources"
        [lazy]="true"
        (onLazyLoad)="onPageChange($event)"
        [responsive]="true"
        [paginator]="true"
        [(rows)]="rows"
        [totalRecords]="totalResources"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [rowsPerPageOptions]="[10,25,50]"
        [(first)]="first"
        styleClass="p-datatable-striped"
        responsiveLayout="stack"
      >
        <ng-template pTemplate="header">
          <th class="selection-column-width"></th>
          <tr>
            <th class="selection-column-width"></th>
            <th>{{'attribute.name' | transloco}}</th>
            <th>{{'attribute.resourceType' | transloco}}</th>
            <th>{{'attribute.description' | transloco}}</th>
            <th>{{'attribute.sharedBy' | transloco}}</th>
            <th>{{'attribute.sharedDate' | transloco}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-shared>
          <tr *ngIf="!loadingSharedResources">
            <td>
              <img src="{{blobs[shared.application]}}" class="p-2" alt="Icon" style="max-width: 50px;"/>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              <p class="text-right md:text-left">{{shared.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.resourceType' | transloco}}</span>
              <p *ngIf="shared.resourceType === 'DEVICE'"
                 class="text-right md:text-left">{{'model.device' | transloco}}</p>
              <p *ngIf="shared.resourceType === 'ASSET'"
                 class="text-right md:text-left">{{'model.asset' | transloco}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              <p class="text-right md:text-left">{{shared.catalogInfo ? shared.catalogInfo['description'] : ''}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.sharedBy' | transloco}}</span>
              <p class="text-right md:text-left">{{shared.sharedByUser}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.sharedDate' | transloco}}</span>
              <p class="text-right md:text-left">{{shared.sharedDate | customDate}}</p>
            </td>
          </tr>
          <tr *ngIf="loadingSharedResources">
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalResources == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalResources > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalResources ? totalResources : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalResources}}
            {{(totalResources > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="resourceName">{{'attribute.resourceName' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.resourceName"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          [focus]="filtersVisible"
          pInputText
          appAutoFocus
          class="w-full"
          id="resourceName"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.entityType' | transloco}}</label>
      </div>
      <div class="col-12 flex flex-column">
        <div>
          <button
            [ngClass]="currentFilters.resourceType == null ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            (click)="setSelectedResourceType(null)"
            pRipple
          >
            <i class="pi pi-circle-off"></i>
            {{'common.all' | transloco}}
          </button>
        </div>
        <div>
          <button
            [ngClass]="currentFilters.resourceType === 'DEVICE' ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            (click)="setSelectedResourceType('DEVICE')"
            pRipple
          >
            <i class="pi pi-mobile"></i>
            {{'model.devices' | transloco}}
          </button>
        </div>
        <div>
          <button
            [ngClass]="currentFilters.resourceType === 'ASSET' ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            (click)="setSelectedResourceType('ASSET')"
            pRipple
          >
            <i class="pi pi-map-marker"></i>
            {{'model.assets' | transloco}}
          </button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
          currentFilters.resourceName ||
          currentFilters.resourceType
        )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
